'use strict';
import React, { PureComponent } from 'react';


class BotonImportarModelo extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
        $('[data-toggle="tooltip"]').tooltip();
    }

    componentWillUnmount() {
        $('.tooltip').tooltip().hide();
    }

    mostrarOcultarImportarModelos(valor) {
        this.props.mostrarOcultarImportarModelos(valor);
    }

    render() {
        return (
            <div className="seccionCabecera__contenedorBotones AsientosContables--floatRight" data-toggle="tooltip" data-title="Importar base de otro modelo" data-placement="left" data-original-title="" title="">
                <div className="seccionCabecera__contenedorBotones--float">
                    <div className="seccionCabecera__botonImportar" onClick={() => this.mostrarOcultarImportarModelos(true)}>
                        <span className="seccionCabecera__iconoImportar"></span>
                    </div>
                </div>
            </div>
        );
    }
}

export default BotonImportarModelo;